import { Behavior } from '../entities/Behavior';

/**
 * Destroys its entity once a number of seconds have passed.
 *
 * What every spawned effect needs and what every game otherwise writes again: a burst of confetti, a
 * "well done" label, a puff of dust. Counting frames here rather than scheduling a timer means the
 * countdown pauses exactly when the game does, because a hidden tab stops producing frames.
 */
export class DestroyAfter extends Behavior {
  readonly #lifetimeSeconds: number;

  #elapsedSeconds = 0;

  constructor(lifetimeSeconds: number) {
    super();
    this.#lifetimeSeconds = lifetimeSeconds;
  }

  /** Seconds left before the entity is destroyed; zero once it has been. */
  get remainingSeconds(): number {
    return Math.max(0, this.#lifetimeSeconds - this.#elapsedSeconds);
  }

  /** Counts down and destroys the entity on the frame the time runs out. */
  override onUpdate(deltaSeconds: number): void {
    this.#elapsedSeconds += deltaSeconds;
    if (this.#elapsedSeconds >= this.#lifetimeSeconds) {
      this.entity.destroy();
    }
  }
}
